import { Dialog } from '@mui/material'

import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { FeedbackConfiguration } from 'context/materialUI/types'

type Props = {
	open: boolean
	response: FeedbackConfiguration
	onClose: () => void
}

function ErrorDialog({ open, response, onClose }: Props): JSX.Element {
	const unsuccessfulCategories = response?.categories?.filter(item => item.success === false) ?? []
	const unsuccessfulOutcomes = response?.outcomes?.filter(item => item.success === false) ?? []
	return (
		<Dialog open={open} onClose={onClose} fullWidth>
			<MDBox
				width={'100%'}
				style={{ backgroundColor: '#fff' }}
				py={3}
				display={'flex'}
				flexDirection={'column'}
				justifyContent={'flex-start'}
				alignItems={'center'}
				gap={1}
			>
				<MDTypography variant="h4" bgColor="info">
					ERROR: Unable to Update Following Values
				</MDTypography>
				{unsuccessfulCategories.length > 0 && (
					<MDTypography variant="h6" mt={1}>
						Categories
					</MDTypography>
				)}
				{unsuccessfulCategories?.map(c => {
					return (
						<MDTypography variant="body2">
							<i>{c.dbAction ?? 'NA'}</i>&nbsp;: {c.name} ({c.memberType})
						</MDTypography>
					)
				})}
				{unsuccessfulOutcomes.length > 0 && (
					<MDTypography variant="h6" mt={1}>
						Outcomes
					</MDTypography>
				)}
				{unsuccessfulOutcomes?.map(o => {
					return <MDTypography variant="body2">{o.name}</MDTypography>
				})}
			</MDBox>
		</Dialog>
	)
}

export default ErrorDialog
